import { get, post, remove } from "@/utils/request";
import apiMap from "@/config";

const riskApi = apiMap.riskApi


export const getRiskDetailsList = data =>
  get(`${riskApi}/risk/userRisk/detail`, data);

export const getRiskList = data => post(`${riskApi}/risk/userRisk/list`, data);

export const getRiskDelete = data =>
  remove(`${riskApi}/risk/userRisk/deleteRiskLevel`, data);

export const getRiskUpdate = data =>
  post(`${riskApi}/risk/userRisk/updateRiskLevel`, data);

export const getRiskAdd = data =>
  post(`${riskApi}/risk/userRisk/addRiskLevel`, data);
